import { isValidCPF, validaCPF } from '../../../../shared/utils/cpfs.ts';

export function normalizeLoginInput(value: string): string {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11) {
    return validaCPF(digits);
  }
  return trimmed.toLowerCase();
}

export function isValidLoginInput(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11) {
    return isValidCPF(digits);
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}
